import { ProNotificationUserEntity } from "../entities/proNotificationUser.entity";

export class ProNotificationModel{
    mails:ProNotificationUserEntity[];
    variables:string[];

    constructor(){}
}